import { v4 as uuidv4 } from 'uuid';
import { SpanContext } from "../renditions";
import type { components } from './types';

export type Span = components['schemas']['Span'] & {
  attributes: {
    'tenant.id': string
  }
};

export type ChildSpan = Partial<
  Omit<Span, 'context' | 'parentId' | 'name' | 'spanKind' | 'parentId' | 'attributes'> &
  {attributes: Omit<Span['attributes'], 'tenant.id' | 'server.address'>}
>

export function createChildSpan(
  name: string,
  parent: Span,
  span?: ChildSpan
) : Span {
  return {
    ...span,
    name,
    startTime: Date.now(),
    context: {
      traceId: parent.context.traceId,
      spanId: uuidv4().replaceAll('-', '').substring(0, 16)
    },
    parentId: parent.context.spanId,
    attributes: {
      'user_agent.original': navigator.userAgent,
      ...span?.attributes,
      // TODO: figure out if we can remove this requirement.
      'server.address': window.location.origin + window.location.pathname,
      'tenant.id': parent.attributes.tenantId,
    },
    spanKind: 'Client',
  }
}

export function createChildSpanFromContext(
  name: string,
  options: {
    tenantId: string,
    context: SpanContext
  },
  span?: ChildSpan
) : Span {
  return {
    ...span,
    name,
    startTime: Date.now(),
    context: {
      traceId: options.context.traceId,
      spanId: uuidv4().replaceAll('-', '').substring(0, 16)
    },
    parentId: options.context.spanId,
    attributes: {
      'user_agent.original': navigator.userAgent,
      ...span?.attributes,
      // TODO: figure out if we can remove this requirement.
      'server.address': window.location.origin + window.location.pathname,
      'tenant.id': options.tenantId,
    },
    spanKind: 'Client',
  }
}